/**
 * @generated SignedSource<<8b7b7fd252d469490ed13a077889ac8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserContentSubmissionDialog_Query$variables = {
  contentNodeId?: string | null | undefined;
  userId?: string | null | undefined;
};
export type UserContentSubmissionDialog_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserContentSubmissionDialog_QueryFragment">;
};
export type UserContentSubmissionDialog_Query = {
  response: UserContentSubmissionDialog_Query$data;
  variables: UserContentSubmissionDialog_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentNodeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentNodeId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardKind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserContentSubmissionDialog_Query",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "contentNodeId",
            "variableName": "contentNodeId"
          },
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "UserContentSubmissionDialog_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserContentSubmissionDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UsersContentSubmissionAdminSchema",
            "kind": "LinkedField",
            "name": "UsersContentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ContentSubmissionsConnection",
                "kind": "LinkedField",
                "name": "ContentSubmissions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentSubmissionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentSubmission",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastUpdated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "rewardResults",
                                    "plural": true,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PassedELearningContentSubmissionDefinition",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentKind",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "rewardResults",
                                    "plural": true,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rewardId",
                                        "storageKey": null
                                      },
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "FailedELearningContentSubmissionDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "learnOpportunity",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LearnOpportunityV2",
                                "kind": "LinkedField",
                                "name": "root",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "structureDefinition",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "extension",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "InfectopharmTreeConfigConsequences",
                                                    "kind": "LinkedField",
                                                    "name": "configConsequences",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "restartTriesCount",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "LearnOpportunityRootExtensionImpl",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "LearnOpportunityRootStructureDefinition",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": [
                  "userId",
                  "contentId"
                ],
                "handle": "connection",
                "key": "UserContentSubmissionDialog_ContentSubmissions",
                "kind": "LinkedHandle",
                "name": "ContentSubmissions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31b8a010b7ca96e60a06f8ad6b5c55d5",
    "id": null,
    "metadata": {},
    "name": "UserContentSubmissionDialog_Query",
    "operationKind": "query",
    "text": "query UserContentSubmissionDialog_Query(\n  $userId: ID\n  $contentNodeId: ID\n) {\n  ...UserContentSubmissionDialog_QueryFragment_3sOmpk\n}\n\nfragment UserContentSubmissionDialog_QueryFragment_3sOmpk on Query {\n  Admin {\n    UsersContentSubmission {\n      ContentSubmissions(first: 20, userId: $userId, contentId: $contentNodeId) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            startedAt\n            lastUpdated\n            definition {\n              __typename\n              status\n              ... on PassedELearningContentSubmissionDefinition {\n                rewardResults {\n                  __typename\n                  kind\n                  rewardKind\n                }\n              }\n              ... on FailedELearningContentSubmissionDefinition {\n                status\n                contentKind\n                rewardResults {\n                  __typename\n                  kind\n                  rewardId\n                  rewardKind\n                }\n              }\n            }\n            learnOpportunity {\n              root {\n                structureDefinition {\n                  __typename\n                  title\n                  ... on LearnOpportunityRootStructureDefinition {\n                    extension {\n                      __typename\n                      ... on LearnOpportunityRootExtensionImpl {\n                        configConsequences {\n                          restartTriesCount\n                        }\n                      }\n                    }\n                  }\n                }\n                id\n              }\n              structureDefinition {\n                __typename\n                title\n              }\n              id\n            }\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d85c6577dd2aff48df43d8330e95805";

export default node;
